/* Ygeia product page — variant selection + the SKYLRK scroll-snap gallery.
   Variant chips drive the cart-form id, price, status, add button, and scroll
   the gallery to the variant's image. The gallery is a bounded vertical run:
   neighbours peek (blurred/dimmed), one frame snaps per gesture, the rails are
   padded so the first and last frames still centre. Thumbnails jump to a frame. */
(function () {
  var main = document.querySelector('.yprod');
  var dataEl = document.getElementById('yprod-data');
  if (!main || !dataEl) return;

  var variants = JSON.parse(dataEl.textContent);
  var idInput = document.getElementById('yprod-variant-id');
  var priceEl = document.getElementById('yprod-price');
  var addBtn = document.getElementById('yprod-add');
  var addLabel = document.getElementById('yprod-add-label');
  var statusEl = document.getElementById('yprod-status');
  var chips = Array.prototype.slice.call(main.querySelectorAll('.opt__chip, .opt__swatch'));

  function fmt(cents) {
    var f = window.ygeiaMoneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var noDec = Math.round(cents / 100).toString();
    return f
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec)
      .replace(/<[^>]*>/g, '');
  }

  /* ------------------------------ gallery ------------------------------- */
  var gallery = main.querySelector('[data-gallery]');
  var slides = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-slide]')) : [];
  var thumbs = Array.prototype.slice.call(main.querySelectorAll('.yprod__thumb'));
  var pos = 0;
  var N = slides.length;

  function indexForId(id) {
    for (var i = 0; i < slides.length; i++) {
      if (String(slides[i].dataset.id) === String(id)) return i;
    }
    return -1;
  }

  // Pad the rails by half the slack so frame 0 and the last frame can centre.
  function padGallery() {
    if (!gallery || !slides.length) return;
    var pad = Math.max(0, (gallery.clientHeight - slides[0].clientHeight) / 2);
    gallery.style.paddingBlock = pad + 'px';
  }

  function setActive(p) {
    pos = p;
    thumbs.forEach(function (t, j) { t.setAttribute('aria-current', String(j === p)); });
    slides.forEach(function (s, j) {
      if (j === p) s.setAttribute('data-current', '');
      else s.removeAttribute('data-current');
    });
  }

  // While a smooth (programmatic) scroll is animating we hold a lock so an
  // auto-recentre can't interrupt it and strand the gallery mid-frame.
  var animating = false;
  var animTimer = 0;
  function scrollToPos(p, smooth) {
    var s = slides[p];
    if (!s || !gallery) return;
    var top = s.offsetTop - (gallery.clientHeight - s.clientHeight) / 2;
    if (smooth !== false) {
      animating = true;
      clearTimeout(animTimer);
      animTimer = setTimeout(function () { animating = false; }, 500);
    }
    gallery.scrollTo({ top: top, behavior: smooth === false ? 'auto' : 'smooth' });
  }

  function centredPos() {
    if (!gallery) return pos;
    var mid = gallery.scrollTop + gallery.clientHeight / 2;
    var best = pos, bestD = Infinity;
    slides.forEach(function (s, j) {
      var d = Math.abs(s.offsetTop + s.offsetHeight / 2 - mid);
      if (d < bestD) { bestD = d; best = j; }
    });
    return best;
  }

  function step(dir) {
    if (N <= 1) return;
    var next = Math.min(N - 1, Math.max(0, pos + dir));
    if (next === pos) return;
    // Instant snap to the next frame — no gradual/partial scrolling.
    scrollToPos((pos = next), false);
    setActive(pos);
  }

  function goToFrame(i, smooth) {
    if (i < 0 || i >= N) return;
    scrollToPos((pos = i), smooth);
    setActive(pos);
  }

  function showImageById(id, smooth) {
    var i = indexForId(id);
    if (i >= 0) goToFrame(i, smooth);
  }

  thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goToFrame(i); }); });

  if (gallery && N > 1) {
    var settle = 0;
    gallery.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(function () { setActive(centredPos()); }, 140);
    }, { passive: true });

    // Advance exactly one frame per gesture (locked until the wheel goes idle
    // ~150ms). At the first/last frame, release the wheel so the scroll passes
    // through to the page instead of being trapped or looping.
    var wheelLocked = false;
    var wheelIdle = 0;
    gallery.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return; // leave horizontal to the browser
      var dir = e.deltaY > 0 ? 1 : -1;
      if ((dir > 0 && pos >= N - 1) || (dir < 0 && pos <= 0)) return; // at the end → let the page scroll on
      e.preventDefault();
      clearTimeout(wheelIdle);
      wheelIdle = setTimeout(function () { wheelLocked = false; }, 150);
      if (wheelLocked) return;
      wheelLocked = true;
      step(dir);
    }, { passive: false });
  }

  // Re-centre after the layout settles (svh/flex/fonts/late images). Crucially,
  // adopt whatever frame is actually centred *now* rather than a stale `pos` —
  // otherwise a recentre firing between a native scroll and the debounced scroll
  // handler would yank the gallery back to the old frame (usually frame 0). And
  // never fight an in-flight smooth scroll.
  function recentre() {
    if (animating) return;
    if (N > 1) setActive(centredPos());
    padGallery();
    scrollToPos(pos, false);
  }
  setActive(0);
  recentre();
  // The gallery height resolves from layout (svh + flex sizing), which can settle
  // after this deferred script runs — re-centre next frame and once fully loaded.
  requestAnimationFrame(recentre);
  window.addEventListener('load', recentre);
  window.addEventListener('resize', recentre);

  /* ------------------------------ variants ------------------------------ */
  var selected = {};
  chips.forEach(function (c) {
    if (c.getAttribute('aria-pressed') === 'true') selected[c.dataset.optionPosition] = c.dataset.value;
  });

  function variantMatching(sel) {
    return variants.find(function (v) {
      return Object.keys(sel).every(function (pos) { return v.options[pos - 1] === sel[pos]; });
    });
  }

  function comboAvailable(pos, val) {
    return variants.some(function (v) {
      if (!v.available) return false;
      if (v.options[pos - 1] !== val) return false;
      return Object.keys(selected).every(function (p) { return p === pos || v.options[p - 1] === selected[p]; });
    });
  }

  function render(initial) {
    chips.forEach(function (c) {
      var p = c.dataset.optionPosition, val = c.dataset.value;
      c.setAttribute('aria-pressed', String(selected[p] === val));
      if (comboAvailable(p, val)) c.removeAttribute('data-unavailable');
      else c.setAttribute('data-unavailable', '');
    });

    var v = variantMatching(selected);
    if (v) {
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = fmt(v.price);
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      if (statusEl) statusEl.textContent = v.available ? (statusEl.dataset.statusAvailable || 'Ready to ship') : 'Sold out';
      if (v.featured_image && v.featured_image.id) showImageById(v.featured_image.id, !initial);
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState(null, '', u);
      } catch (e) {}
    } else if (addBtn) {
      addBtn.disabled = true;
      if (addLabel) addLabel.textContent = 'Unavailable';
    }
  }

  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      selected[c.dataset.optionPosition] = c.dataset.value;
      render();
    });
  });

  render(true);
})();
